/**
 * La date civile du jour à Madagascar (revue S01, C11).
 *
 * L'API tourne en UTC et l'écran à l'heure du poste : entre 0 h et 3 h,
 * heure de Madagascar, ils ne disaient pas le même « aujourd'hui ». Les
 * règles qui comparent une date au jour (départ d'un salarié, 21 ans d'un
 * enfant) prennent toutes celle-ci, des deux côtés.
 *
 * Madagascar est à UTC+3 toute l'année (pas d'heure d'été) : un décalage
 * fixe suffit, sans dépendre des fuseaux connus du navigateur.
 */
import { jourAMadagascar } from './jour-civil.js';
/**
 * AAAA-MM-JJ, le jour qu'il est à Antananarivo à l'instant `maintenant`. Le
 * calcul est celui de `jourAMadagascar` (décision 447) : un seul décalage.
 */
export function dateCivileAMadagascar(maintenant = new Date()) {
    return jourAMadagascar(maintenant);
}
//# sourceMappingURL=date-civile.js.map